import { render, staticRenderFns } from "./bulk-request-modal-loader.vue?vue&type=template&id=5c899922"
import script from "./bulk-request-modal-loader.vue?vue&type=script&lang=js"
export * from "./bulk-request-modal-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports